module.exports = __webpack_public_path__ + "img/logo_ko.7febfa29.svg";